export default {
    APLICA: {
        id: "APLICA",
        nome: "Aplica",
    },
    NAO_SE_APLICA: {
        id: "NAO_SE_APLICA",
        nome: "Não se aplica",
    }
}